// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCdvr19isxVmlNgYIJkDxXX8VIMgv8FQWw",
    authDomain: "learning-site-b9858.firebaseapp.com",
    projectId: "learning-site-b9858",
    storageBucket: "learning-site-b9858.appspot.com",
    messagingSenderId: "706330916346",
    appId: "1:706330916346:web:d1e09f6f85a2144d3be043"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;